import React from "react";
import axios from 'axios'
import { toast, } from 'react-toastify';
import withStyles from "@material-ui/core/styles/withStyles";
import Codeicon from "../../assets/img/code_icon.png";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import Menu from "../Menu";
import { Link } from "react-router-dom";
import ForgotPasswordStyle from './ForgotPasswordStyle'
import image from "../../assets/img/login_bg.png";
import Menu1 from '../Menu1'
import { BASE_URL } from "../../utils/handleApi";
class ForgotPassword2 extends React.Component {
  
  state = {
    otp: "",
    errors: {
      otp: "",
    },
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    let errors = this.state.errors;
    switch (name) {
      case "otp":
        errors.otp =
          value.length !== 6
            ? "OTP must be 6 characters long!"
            : "";
        break;
      default:
        break;
    }
    this.setState({ errors, [name]: value });
  };

  handleKeyDown = (e) => {
    if(e.keyCode === 32){
      e.preventDefault();
    }
  }

  validateError = () => {
    let hasError = false;
    let errors = this.state.errors || {};

    if(!this.state.otp){
      errors.otp = "Please enter valid OTP!";
    } else if(this.state.otp.length !== 6){
      errors.otp = "OTP must be 6 characters long!";
    } else {
      errors.otp = ""
    }

    this.setState({ errors });
    for (const value of Object.values(errors)) {
      if(value.length > 0)
        hasError = true
      else
        hasError = false
    }
    return hasError;
  }

  handleLogin = () => {
    if (!this.validateError(this.state.errors)) {
      axios.post(`${BASE_URL}/vendor/validateOTP`, {
        email_address: this.props.location.state,
        otp: this.state.otp,
      })
      .then(res => {
        if(res.status === 200){
          toast.success('Valid OTP entered, please change your password!')
          this.props.history.push({ pathname: '/Reset', state: this.props.location.state })
        }
      })
      .catch(err => {
        if(err.response.status === 404){
          return toast.error('Please enter valid OTP!')
        }
        toast.error('Some error happened!')
      })
    }
  }

  

  render() {
    const { classes } = this.props;
    const { errors } = this.state;
    return (
      <div>
      {localStorage.getItem('token', this.props.data) ? <Menu/> : <Menu1 /> }
        <div
          className={classes.pageHeader}
          style={{
            backgroundImage: "url(" + image + ")",
            backgroundSize: "cover",
            backgroundPosition: "top center",
          }}
        >
          <div className={classes.container}
          style={{marginTop:"4%"}}>
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={4}>
                <Card className={classes.card}>
                  <form className={classes.form} onSubmit={this.handleLogin} noValidate>
                    <CardHeader
                      color="success"
                      signup
                      className={classes.cardHeader}
                    >
                      <h4 className={classes.cardTitle}>Enter OTP</h4>
                      <div className={classes.socialLine}></div>
                    </CardHeader>

                    <CardBody style={{ marginTop: "30px" }} signup>
                        
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <img
                          style={{ height: "4vh", marginTop: "3.5vh" }}
                          src={Codeicon}
                          alt="Pic"
                        />

                        <input
                          style={{marginTop:"18px", fontSize: "16px"}}
                          className={classes.input}
                          type="text"
                          name="otp"
                          placeholder="OTP..."
                          onChange={this.handleChange}
                          onKeyDown={this.handleKeyDown}
                          maxLength={6}
                        />
                      </div>
                        {errors.otp.length > 0 && (
                          <span style={{ display:"flex",justifyContent:"flex-start",paddingLeft:"13%",marginTop:"3px",fontSize:"12px",color:"red"}} >{errors.otp}</span>
                        )}
                    </CardBody>
                    
                    <div style={{margin:"20px 40px",paddingBottom:'15px'}}className={classes.textCenter}>
                      <Link to="/Forgot"><Button  style={{outline:"none"}} outline="none"color="success" className={classes.button}>
                        PREV
                      </Button>
                      </Link>
                     <Button disabled={!this.state.otp} onClick={this.handleLogin} style={{outline:"none"}} outline="none"color="success" className={classes.button}>
                        NEXT
                      </Button>
                     
                    </div>
                   
                  </form>
                </Card>
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(ForgotPasswordStyle)(ForgotPassword2);
